import { Grid, Typography, Box } from '@mui/material'
import { GRAY_COLORS } from 'asterX-UI'
import { Nodata } from 'asterX-UI/Icons/Nodata'

export const NotFound = ({ title = 'Нет данных', fontSize = '21px' }) => {
  return (
    <Grid container justifyContent="center">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: '20px'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 1.5,
            borderRadius: 1,
            border: `1px solid ${GRAY_COLORS[200]}`,
            backgroundColor: '#fff'
          }}
        >
          <Nodata />
        </Box>

        <Typography
          sx={{
            display: 'flex',
            alignItems: 'center',
            marginTop: 2,
            fontSize: fontSize || '21px',
            fontWeight: 600,
            lineHeight: '24px',
            color: GRAY_COLORS[900]
          }}
        >
          {title}
        </Typography>
      </Box>
    </Grid>
  )
}
